import React from "react";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import { useTranslation, SUPPORTED_LANGUAGES, type Language } from "../../i18n";

// LanguageSwitcher:顶栏语言切换。点选后持久化到 localStorage 并即时切换 antd 与文案。
const LanguageSwitcher: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const { lang, setLang, t } = useTranslation();

  const items: MenuProps["items"] = SUPPORTED_LANGUAGES.map((item) => ({
    key: item.value,
    label: item.label,
  }));

  const current = SUPPORTED_LANGUAGES.find((l) => l.value === lang);

  return (
    <Dropdown
      menu={{
        items,
        selectable: true,
        selectedKeys: [lang],
        onClick: ({ key }) => setLang(key as Language),
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <span
        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }}
        title={t("common.language")}
      >
        <i className="ri-translate-2" />
        {!compact && <span>{current?.label || lang}</span>}
      </span>
    </Dropdown>
  );
};

export default LanguageSwitcher;
